module.exports = __webpack_public_path__ + "static/media/especialidades-bg.a27ce49f.jpg";